import { drawArrow } from "./arrows";

export const wall = (p5, trait, width, yurtTrait) => {
  const xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const boardWidth = trait.twoByW;

  const rightBoard = {
    x: xcenter + (trait.w / 2 - trait.twoByW / 2),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const leftBoard = {
    x: xcenter - (trait.w / 2 - trait.twoByW / 2),
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const bottomBoard = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + boardWidth / 2),
    w: trait.w,
    h: boardWidth,
  };

  const topBoard = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth / 2) + boardWidth / 2,
    w: trait.w,
    h: boardWidth,
  };

  const rafterPlate = {
    x: xcenter,
    y: ycenter - (yurtTrait.h / 2 + boardWidth),
    w: trait.w,
    h: boardWidth,
  };

  const centerStud = {
    x: xcenter,
    y: ycenter,
    w: boardWidth,
    h: yurtTrait.h,
  };

  const blocking = {
    x: xcenter,
    y: ycenter + (yurtTrait.h / 2 + boardWidth / 2) - 96 * trait.pixels,
    w: trait.w,
    h: trait.twoByH,
  };

  // right board
  p5.push();
  p5.rectMode(p5.CENTER);
  p5.fill("lightgrey");

  if (!trait.windows && !trait.doors) {
    if (yurtTrait.h > 96 * trait.pixels && !trait.doors) {
      p5.rect(blocking.x, blocking.y, blocking.w, blocking.h);
    }
    if (yurtTrait.stud / trait.pixels >= 24) {
      p5.rect(centerStud.x, centerStud.y, centerStud.w, centerStud.h);
    } else {
      p5.rect(
        centerStud.x - trait.w / 3 / 2,
        centerStud.y,
        centerStud.w,
        centerStud.h
      );
      p5.rect(
        centerStud.x + trait.w / 3 / 2,
        centerStud.y,
        centerStud.w,
        centerStud.h
      );
    }
  }

  if (trait.doors) {
    if (yurtTrait.stud / trait.pixels >= 24) {
      p5.rect(
        centerStud.x,
        centerStud.y - trait.doorH / 2,
        centerStud.w,
        centerStud.h - trait.doorH
      );
    } else {
      p5.rect(
        centerStud.x - trait.w / 3 / 2,
        centerStud.y - trait.doorH / 2,
        centerStud.w,
        centerStud.h - trait.doorH
      );
      p5.rect(
        centerStud.x + trait.w / 3 / 2,
        centerStud.y - trait.doorH / 2,
        centerStud.w,
        centerStud.h - trait.doorH
      );
    }
  }

  p5.rect(rightBoard.x, rightBoard.y, rightBoard.w, rightBoard.h);
  p5.rect(leftBoard.x, leftBoard.y, leftBoard.w, leftBoard.h);
  p5.rect(topBoard.x, topBoard.y, topBoard.w, topBoard.h);
  p5.rect(rafterPlate.x, rafterPlate.y, rafterPlate.w, rafterPlate.h);

  if (yurtTrait.bottomPlate === "CEDAR") {
    p5.fill("#966F33");
  }
  p5.rect(bottomBoard.x, bottomBoard.y, bottomBoard.w, bottomBoard.h);

  if (yurtTrait.bottomPlate === "CEDAR") {
    p5.fill("#966F33");
    p5.textAlign(p5.CENTER);
    p5.textSize(20);
    p5.textStyle(p5.BOLD);
    p5.text("CEDAR", bottomBoard.x, bottomBoard.y + 25);
  }

  p5.pop();

  const arrowDistance = 6 * trait.pixels;

  // right arrow
  let v0 = p5.createVector(
    bottomBoard.x + bottomBoard.w / 2 + arrowDistance,
    bottomBoard.y + bottomBoard.h / 2
  );
  let v1 = p5.createVector(0, -yurtTrait.h - boardWidth * 2.5);
  drawArrow(p5, v0, v1, yurtTrait.h, trait.pixels);

  // left arrow
  let v2 = p5.createVector(
    bottomBoard.x - bottomBoard.w / 2 - arrowDistance,
    bottomBoard.y + bottomBoard.h / 2 - boardWidth
  );
  let v3 = p5.createVector(0, -yurtTrait.h + trait.twoByW);
  drawArrow(p5, v2, v3, yurtTrait.h - boardWidth * 3, trait.pixels);

  // siding(p5, trait, yurtTrait, xcenter, ycenter, boardWidth)
};
